<template>
  <v-theme-provider>
    <base-section id="com-syariah" space="10">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <base-section-heading title="Dewan Pengawas Syariah" />
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="search"
              placeholder="Ketik kata kunci disini..."
              prepend-inner-icon="mdi-magnify"
              filled
              rounded
              dense
              class="centered-icon"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <base-body space="0">
              <v-container fluid>
                <v-row dense :justify="isCentered ? 'center' : 'start'">
                  <v-col
                    v-for="(card, index) in filteredCards"
                    :key="card.name"
                    cols="12"
                    md="3"
                  >
                    <v-card
                      @click="PersonDetail(card.src, card.name, card.detail, card.title)"
                      class="card-img"
                    >
                      <div>
                        <v-img
                          :src="require(`@/assets/${card.src}`)"
                          height="380px"
                          class="img-preview"
                        ></v-img>
                      </div>

                      <v-card-title class="profile-name">{{
                        card.name
                      }}</v-card-title>
                      <v-card-subtitle style="color: black">
                        {{ card.title }}
                      </v-card-subtitle>
                      <v-expand-transition>
                        <div v-show="show[index]">
                          <v-divider></v-divider>
                          <v-card-text>{{ card.detail }}</v-card-text>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                </v-row>
                <v-dialog
                  v-model="dialog.detail"
                  max-width="90%"
                  persistent
                  style="border-radius: 20px"
                >
                  <v-card>
                    <v-card-actions style="height: 80px">
                      <span class="primary--text">{{detail.title}}</span>
                      <v-spacer></v-spacer>
                      <v-btn
                        rounded
                        outlined
                        color="grey"
                        dark
                        @click="dialog.detail = false"
                        class="mr-5"
                      >
                        X
                      </v-btn>
                    </v-card-actions>
                    <v-divider></v-divider>
                    <v-progress-linear
                      indeterminate
                      v-if="loading.detail"
                    ></v-progress-linear>
                    <v-container>
                      <v-row class="mx-2">
                        <v-col cols="12" sm="3" class="text-center mb-4">
                          <v-avatar size="165">
                            <v-img
                              contain
                              :src="
                                detail.img
                                  ? require(`@/assets/thumb-${detail.img}`)
                                  : require('@/assets/user-no-photo.png')
                              "
                              :alt="
                                detail.img ? detail.img : 'Placeholder Image'
                              "
                              :style="{ border: '1px solid #ccc' }"
                            />
                          </v-avatar>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="9"
                          class="text-h4 display-flex justify-center align-center text-center-sm"
                          style="align-self: center; color: #114e87"
                        >
                          {{ detail.name }}
                        </v-col>
                        <v-col cols="12">
                          <div
                            class="display-flex text-justify"
                            v-html="detail.description"
                          ></div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-dialog>
              </v-container>
            </base-body>
          </v-col>
          <!-- <v-col cols="12">
            <base-section-heading title="Divisi" />
          </v-col>
          <v-col
          v-for="(division, i) in divisions"
          :key="i"
          cols="4"
          md="4"
        >
          <v-card
            color="secondary"
            class="mx-auto"
          >
            <v-card-item>
              <div>
                <div class="text-overline mb-1 text-center white--text">
                  {{ division }}
                </div>
              </div>
            </v-card-item>

            <v-card-actions>
              <v-btn>
                Button
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
//import Avatar from "../../components/base/Avatar.vue";
export default {
  //components: { Avatar },
  name: "SectionBoards",
  data() {
    return {
      search: "", // Data untuk menyimpan nilai pencarian
      show: [], // array untuk menyimpan nilai show untuk setiap kartu
      detailShow: [],
      transition: [],
      dialog: {
        detail: false,
      },
      loading: {
        detail: false,
      },
      detail: {
        name: "",
        img: "",
        description: "",
      },
      cards: [
        {
          name: "Agus Haryadi",
          title: "Ketua Dewan Pengawas Syariah",
          src: "agus-haryadi.png",
          thumbnail: "agus-haryadi.png",
          detail:
            `<div>
            <p>
              Warga Negara Indonesia, lahir pada tahun 1962. Saat ini berdomisili di Bogor. Memperoleh gelar Insinyur di Bidang Matematika dari Institut Teknologi Bandung. Memiliki sertifikasi keahlian di beberapa bidang diantaranya adalah:
            </p>
            <ul>
              <li>Associate of Society of Actuaries of Indonesia (ASAI)</li>
              <li>Ajun Ahli Asuransi Indonesia - Jiwa (AAAI-J)</li>
              <li>Fellow of Islamic Insurance Society (FIIS)</li>
              <li>Pengawas Syariah (LSP-MUI)</li>
              <li>Ahli Syariah Pasar Modal (LSP-MUI)</li>
              <li>Profesional Tata Kelola Risiko Berkualifikasi (QRGP)</li>
            </ul>
            <br>
            <p><strong>Saat ini menjabat beberapa posisi sebagai berikut:</strong></p>
            <ul>
              <li>Anggota Dewan Pengawas Syariah PT BRI Life sejak 2015</li>
              <li>Ketua Dewan Pengawas Syariah PT Ace Life/Chubb Life sejak 2014</li>
              <li>Ketua Dewan Pengawas Syariah PT BNI Life sejak 2010</li>
            </ul>
            <br>
            <p><strong>Sebelumnya menjabat beberapa posisi sebagai berikut:</strong></p>
            <ul>
              <li>Komisaris Independen PT. Asuransi Chubb Syariah (2021–2025)</li>
              <li>Anggota Dewan Pengawas Syariah PT Paytren Aset Manajemen (2017–2022)</li>
              <li>Anggota Dewan Pengawas Syariah PT Asuransi Takaful Umum (2018–2021)</li>
              <li>Anggota Dewan Pengawas Syariah PT Capitalinc Multifinance (2015–2026)</li>
              <li>Anggota Dewan Pengawas Syariah PT Amanah Finance (2006–2016)</li>
              <li>Direktur Utama PT Asuransi Takaful Keluarga (2002–2005)</li>
              <li>Direktur Operasional PT Asuransi Takaful Keluarga (1997–2002)</li>
            </ul>

            <p>
              Lulus fit and proper test OJK sebagai Ketua DPS PT. Orion Penjaminan Indonesia sesuai SK OJK No. KEP-237/PD.02/2025 tanggal 21 April 2025.
            </p>
        </div>`,
        },
        {
          name: "Hasbi Mauriza Hasyim",
          title: "Anggota Dewan Pengawas Syariah",
          src: "hasbi-mauriza-hasyim.jpg",
          thumbnail: "thumb-hasbi-mauriza-hasyim.jpg",
          detail:
            `<div>
            <p>
              Warga Negara Indonesia, lahir pada tahun 1964. Saat ini berdomisili di Bekasi. Memperoleh gelar Insinyur di Bidang Teknik & Manajemen Industri dari Institut Teknologi Nasional Bandung serta Pendidikan Bahasa Arab dari Universitas Padjadjaran dan University of Jordan, Amman. 
              Memiliki sertifikasi keahlian di bidang:
            </p>
            <ul>
              <li>Pengawas Syariah dari LSP DSN-MUI</li>
              <li>Manajemen Risiko Level-IV dari LSP BSMR</li>
            </ul>
            <br>
            <p><strong>Saat ini menjabat sebagai:</strong></p>
            <ul>
              <li>Ketua Dewan Pengawas Syariah PT Trihamas Finance Syariah sejak 2018</li>
              <li>Anggota DPS PT KB Bukopin Finance, Unit Usaha Syariah sejak 2017</li>
            </ul>
            <br>
            <p><strong>Sebelumnya menjabat beberapa posisi sebagai berikut:</strong></p>
            <ul>
              <li>Anggota Dewan Pengawas Syariah PT BPRS Mitra Harmoni Bandung (2011–2024)</li>
              <li>Anggota Dewan Pengawas Syariah PT BPRS Cipaganti Bandung (2011–2017)</li>
              <li>Anggota Dewan Pengawas Syariah PT Trihamas Finance UUS (2007–2019)</li>
              <li>Direktur Utama PT BPRS Berkah Amal Sejahtera (1990–1995)</li>
            </ul>

            <p>
              Lulus fit and proper test OJK sebagai Anggota DPS PT. Orion Penjaminan Indonesia sesuai SK OJK No. KEP-248/PD.02/2025 tanggal 22 April 2025.
            </p>
          </div>`,
        },
      ],
    };
  },
  computed: {
    isCentered() {
      return this.filteredCards.length === 2
    },
    // Filter kartu berdasarkan nilai pencarian
    filteredCards() {
      return this.cards.filter((card) => {
        // Memeriksa apakah nama atau detail kartu cocok dengan nilai pencarian
        return (
          card.name.toLowerCase().includes(this.search.toLowerCase()) ||
          card.detail.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
  methods: {
    toggleCard(index) {
      // Mengganti nilai show untuk kartu dengan indeks yang diberikan
      this.$set(this.show, index, !this.show[index]);
    },
    toggleDetail(index) {
      // Mengganti nilai show detail untuk kartu dengan indeks yang diberikan
      this.$set(this.detailShow, index, !this.detailShow[index]);
    },
    zoomIn(index) {
      // Mengubah nilai efek grayscale dan zoom saat hover
      this.$set(this.grayscale, index, "grayscale(0%)");
      this.$set(this.zoom, index, "scale(1.2)");
    },
    zoomOut(index) {
      // Mengubah nilai efek grayscale dan zoom saat hover
      this.$set(this.grayscale, index, "grayscale(100%)");
      this.$set(this.zoom, index, "scale(1)");
    },
    PersonDetail(image, name, desc, title) {
      this.dialog.detail = true;
      this.detail.img = image;
      this.detail.name = name;
      this.detail.description = desc;
      this.detail.title = title;
    },
  },
  created() {
    // Inisialisasi nilai show untuk setiap kartu menjadi false
    // this.cards.forEach(() => {
    //   this.show.push(false);
    //   this.detailShow.push(false);
    //   this.grayscale.push("grayscale(100%)");
    //   this.zoom.push("scale(1)");
    //   this.transition.push("0.3s ease-in-out;");
    // });
  },
};
</script>

<style scoped>
.image-container {
  filter: grayscale(100%);

  overflow: hidden;
  cursor: pointer;
  background-color: #fff;
  -webkit-box-shadow: -5px 7px 130px -20px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 7px 130px -20px rgba(0, 0, 0, 0.15);
  height: 100%;
  position: relative;
}
.img-preview:hover {
  -webkit-transform: scale(1.5);
  transform: scale(1.2);
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
}
.card-img {
  border-radius: 12px;
}

.profile-name {
  margin-bottom: 5px;
  font-family: "Reckless";
  font-size: 17px;
  font-weight: bold;
  line-height: 35px;
  color: #0c4f88;
}
.text-center-sm {
  @media (max-width: 600px) {
    text-align: center;
  }
}
</style>
